import { Helmet, HelmetProvider } from 'react-helmet-async';
import favicon from '../imagenes/logoutm.png'
import ListarGestionVisita from '../componentes/ListarGestionVisitas';

const GestionVisitas = () => {
    return (
        <>
            <HelmetProvider>
                <div>
                    <Helmet>
                        <link rel="shortcut icon" href={favicon} type="image/x-icon"/>
                        <title>Gestión de Visitas - Sistema de Administración Museo UTM</title>
                    </Helmet>
                </div>
            </HelmetProvider>

            <ListarGestionVisita />
        </>
    );
}

export default GestionVisitas;